import React, {useEffect, useState} from "react";
import {List, Avatar, Card, message,Select, Button} from 'antd';
import {getHostAddress,getFileAddress,getFrontEndAddress} from "../../Tool/UtileFun";
import cookie from "react-cookies";
import FileViewer from "react-file-viewer";
import {Unsuppor} from "./Unsuppor";
import {FileViewerTool} from "../Util/fileViewer/FileViewerTool";
import {NewCardIMGPage} from "./NewCardIMGPage";


export function ExperimentResourcesList(){

    useEffect(
        ()=>{
            //旧方案的  先关闭节省资源
            //findAllKnowledgeList()
            //findExperiment()
        },[]
    )
    const [resources,setResources] = useState([])
    const [resourcesAddress,setResourcesAddress] = useState([])
    const [experiment,setExperiment] = useState([])
    const { Option } = Select;
    const classId = "classID"

    //根据实验id获取实验资源
    const findSourcesAddress=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/findByExperimentIdAndKnowledgeLibrary",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({id:value}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setResourcesAddress(data)
            })
            .catch(error => message.error("error"+error));
    }
    //查找这个班级可以参与的所有实验
    const findExperiment=()=>{
        fetch(
            "http://"+getHostAddress()+"/experiment/findClassExperiment",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({classId:cookie.load(classId)}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
               setExperiment(data)
                console.log("可参与的实验")
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }

    const findAllKnowledgeList=()=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/findAllKnowledgeList",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                console.log(data)
                setResources(data)
            })
            .catch(error => message.error("error"+error));
    }

    const data = [
        {
            title: 'Ant Design Title 1',
        },
        {
            title: 'Ant Design Title 2',
        },
        {
            title: 'Ant Design Title 3',
        },
        {
            title: 'Ant Design Title 4',
        },
    ];

    const icon = (type)=>{
        if (type === 'xlsx'){
            return "http://"+getFileAddress()+"/experimentResources/icon/xlsx.jpg"
        }
        if (type === 'pptx'){
            return "http://"+getFrontEndAddress()+"/experimentResources/icon/ppt.jpg"
        }
        if (type === 'docx'){
            return "http://"+getFileAddress()+"/experimentResources/icon/docx.jpg"
        }
        if (type === 'jpg'){
            return "http://"+getFrontEndAddress()+"/experimentResources/icon/picture.jpg"
        }
        return "http://"+getFileAddress()+"/experimentResources/icon/otherFile.jpg"
    }

    const download = url => {
        // const eleLink = document.createElement('a');
        // eleLink.style.display = 'none';
        // // eleLink.target = "_blank"
        // eleLink.href = "http://"+getFileAddress+"/experimentResources/knowledgeLibrary/%E6%96%AF%E5%A4%A7%E6%9E%97.jpg";
        // // eleLink.href = record;
        // document.body.appendChild(eleLink);
        // eleLink.click();
        // //document.body.removeChild(eleLink);
        //window.open(url,"_blank");
        window.location.href  = url
        console.log(url)
        console.log("click")
    };

    const handleChange = (value) => {
        console.log(`selected ${value}`);
        findSourcesAddress(value)
    }

    const select = (
        <Select defaultValue="" style={{ width: 120 }} onChange={handleChange}>
            {experiment.map(ex=><Option value={ex.id}>{ex.target}</Option>)}
        </Select>
    )


    return(
        //原分班级资源的代码
        // <Card title={"实验资源"}>
        //     {select}
        //     <List
        //         itemLayout="horizontal"
        //         dataSource={resourcesAddress}
        //         renderItem={item => (
        //             <List.Item
        //                 actions={[<a  href={item.resourcesAddress} key="list-loadmore-edit" target={"_blank"} download="filename">download</a>, <a key="list-loadmore-more">delete</a>]}
        //             >
        //                 <List.Item.Meta
        //                     avatar={<Avatar src={icon(item.type)} />}
        //                     title={<a href={item.resourcesAddress} download={item.resourcesName}>{item.resourcesName}</a>}
        //                     description={item.content}
        //                 />
        //             </List.Item>
        //         )}
        //     />
        // </Card>

        //新的组件页面
        <>
            <NewCardIMGPage></NewCardIMGPage>
        </>
    )
}
